<template>
	<section class="addresses-filter" v-if="filtersData" v-show="!pawnId" v-cloak>
	<div class="addresses-filter__top">
		<div class="addresses-filter__top-group">
		<div class="addresses-filter__top-item">
			<div class="default-input">
			<div class="default-input__select">
				<Multiselect 
					:placeholder="'Выберите регион'" 
					:noOptionsText="'Не найдено'" 
					:searchable="true"
					:can-deselect="false" 
					:can-clear="false" 
					v-model="region"
					:label="'name'" 
					:value-prop="'id'" 
					:noResultsText="'Регион не найден'" 
					:options="filtersData.regions"
					@change="clearFilter()"
				></Multiselect>
			</div>
			</div>
		</div>
		<div class="addresses-filter__top-item">
			<div class="default-input">
			<div class="default-input__select">
				<Multiselect
                        :noOptionsText="'Не найдено'"
                        :searchable="true"
                        autocomplete="new-password"
                        :placeholder="'Выберите город'" :disabled="!region" :can-deselect="false" :can-clear="false"
				v-model="city" :label="'name'" :value-prop="'id'" :noResultsText="'Город не найден'" @change="clearAdditionalFilters()"
				:options="citiesList"></Multiselect>
			</div>
			</div>
		</div>
		<div class="addresses-filter__top-item" v-if="city && districtsList.length">
			<div class="default-input">
			<div class="default-input__select">
				<Multiselect  :noOptionsText="'Не найдено'" :searchable="true"  :placeholder="'Выберите район'" :disabled="!city || !districtsList.length" v-model="district"
				:label="'name'" :value-prop="'id'" :noResultsText="'Район не найден'" :options="districtsList">
				</Multiselect>
			</div>
			</div>
		</div>
		</div>
		<div class="addresses-filter__top-item">
		<address-search v-model="address" :tooltips-data="pawnsList">
			<template #tooltip="{ tooltip }">
			<div class="default-input__tooltip-item" @click="address = `${tooltip.street}, ${tooltip.house}`">{{
				tooltip.street }} {{ tooltip.house }}</div>
			</template>
		</address-search>
		</div>
		<div class="addresses-filter__top-item" v-if="currentView === 'map'">
		<div class="default-checkbox">
			<input class="default-checkbox__input" v-model="showClosest" type="checkbox" id="filter-closest">
			<label class="default-checkbox__label" for="filter-closest">Показать ближайшие</label>
		</div>
		</div>
		<div class="addresses-filter__top-item">
		<div class="default-checkbox">
			<input class="default-checkbox__input" v-model="is_open" type="checkbox" id="filter-is_open">
			<label class="default-checkbox__label" for="filter-is_open">Открыто сейчас</label>
		</div>
		</div>
		<div class="addresses-filter__top-item">
		<div class="more-filters" :class="{ active: openFull }" @click="openFull = !openFull">Расширенный поиск</div>
		</div>
	</div>
	<div class="addresses-filter__hidden" :class="{ active: openFull }">
		<div class="af-filters">
		<div class="af-filters__col">
			<template v-if="filtersData.accepts && filtersData.accepts.length">
			<div class="af-filters__title">Что принимаем</div>
			<div class="af-filters__items">
				<div class="default-checkbox" v-for="item in filtersData.accepts" :key="item.id">
				<input class="default-checkbox__input" type="checkbox" :id="`filter-accept-${item.id}`" :value="item.id"
					@change="setFilter('accepts', item.id)" :checked="~accepts.map(v=>+v).indexOf(+item.id)">
				<label class="default-checkbox__label" :for="`filter-accept-${item.id}`">{{ item.name }}</label>
				</div>
			</div>
			</template>
		</div>
		<div class="af-filters__col">
			<template v-if="filtersData.sales && filtersData.sales.length">
			<div class="af-filters__title">Акции и распродажи</div>
			<div class="af-filters__items af-filters__items--1">
				<div class="default-checkbox" v-for="item in filtersData.sales" :key="item.id">
				<input class="default-checkbox__input" type="checkbox" :id="`filter-sales-${item.id}`" :value="item.id"
					@change="setFilter('sales', item.id)" :checked="~sales.map(v=>+v).indexOf(+item.id)">
				<label class="default-checkbox__label" :for="`filter-sales-${item.id}`">{{ item.name }}</label>
				</div>
			</div>
			</template>
		</div>
		<div class="af-filters__col">
			<template v-if="filtersData.accepts && filtersData.accepts.length">
			<div class="af-filters__title">Услуги</div>
			<div class="af-filters__items">
				<div class="default-checkbox" v-for="item in filtersData.services" :key="item.id">
				<input class="default-checkbox__input" type="checkbox" :id="`filter-services-${item.id}`" :value="item.id"
					@change="setFilter('services', item.id)" :checked="~services.map(v=>+v).indexOf(+item.id)">
				<label class="default-checkbox__label" :for="`filter-services-${item.id}`">{{ item.name }}</label>
				</div>
			</div>
			</template>
		</div>
		</div>
	</div>
	</section>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AddressSearch from "@/components/utils/AddressSearch";

export default {
	name: "PawnshopsFilter",
	components: { AddressSearch, Multiselect },
	emits : [ 'region:changed', 'city:changed' ],
	props: {
		pawnId: {
			type: Number,
			default: 0
		},
		cityId: {
			type: [ Number, String ],
			default: 0
		},
		regionId: {
			type: [ Number, String ],
			default: 0
		},
		filter: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			openFull: true,
		}
	},
	mounted() {
		if(this.pawnId) {
			this.setPawnsFiltersKey({key: 'pawn_id', value: this.pawnId})
		}
		let initialFilters = this.filter;
		for (let filterName in this.pawnsFilters) {
			if (
				initialFilters[ filterName ]
			) {
				this[ filterName ] = Array.isArray(initialFilters[ filterName ])
					? initialFilters[ filterName ]
					: [ initialFilters[ filterName ] ];
			}
		}
		
		this.loadFiltersData().then(() => {
			if (this.regionId) {
				this.region = this.regionId;
			}
			if (this.cityId) {
				this.city = this.cityId;
			}
			if (
				!this.region && !this.city &&
				(this.userCity || {}).id
			) {
				this.region = this.userCity.region?.id;
				this.city 
			}
		});
	},
	watch : {
		userCity : {
			handler (userCity) {
				if (!this.region) {
					this.region = userCity.region?.id
					if (!this.city) {
						this.city = userCity.id
					}
				}
			},
			deep : true,
		},
		region () {
			if (this.region) {
				let region = this.filtersData.regions?.find(c => c.id == this.region);
				if (region) {
					this.$emit('region:changed', region);
				}
			}
		},
		city () {
			if (this.city) {
				let city = this.citiesList?.find(c => c.id == this.city);
				if (city) {
					this.$emit('city:changed', city);
				}
			}
		},
	},
	computed: {
		cities () {
			return this.filtersData.cities || [];
		},
		citiesList() {
			return this.cities.filter(c => c.region == this.region);
		},
		districtsList() {
			return this.getDistricts(this.getPawnsFilterKey('city'))
		},
		region: {
			get() {
				return this.getPawnsFilterKey('region')
			},
			set(value) {
				if(!this.pawnId) {
					this.setPawnsFiltersKey({key: 'region', value: value})
					// this.setPawnsFiltersKey({key: 'city', value: this.citiesList[0]?.id})
				}
			}
		},
		city: {
			get() {
				return this.getPawnsFilterKey('city')
			},
			set(value) {
				if(!this.pawnId) {
					this.setPawnsFiltersKey({key: 'city', value: value})
				}
			}
		},
		district: {
			get() {
				return this.getPawnsFilterKey('district')
			},
			set(value) {
				this.setPawnsFiltersKey({ key: 'district', value: value })
			}
		},
		address: {
			get() {
				return this.getPawnsFilterKey('address')
			},
			set(value) {
				this.setPawnsFiltersKey({ key: 'address', value: value })
			}
		},
		accepts: {
			get() {
				return this.getPawnsFilterKey('accepts')
			},
			set(value) {
				this.setPawnsFiltersKey({ key: 'accepts', value: value })
			}
		},
		sales: {
			get() {
				return this.getPawnsFilterKey('sales')
			},
			set(value) {
				this.setPawnsFiltersKey({ key: 'sales', value: value })
			}
		},
		services: {
			get() {
				return this.getPawnsFilterKey('services')
			},
			set(value) {
				this.setPawnsFiltersKey({ key: 'services', value: value })
			}
		},
		showClosest: {
			get() {
				return this.showClosesStatus
			},
			set(value) {
				this.setShowClosest(value)
			}
		},
		is_open: {
			get() {
				return this.getPawnsFilterKey('is_open')
			},
			set(value) {
				this.setPawnsFiltersKey({ key: 'is_open', value: value })
			}
		},
		...mapGetters({
			pawnsFilters: 'pawns/getPawnsFilters',
			filtersData: 'pawns/getPawnsFiltersData',
			getPawnsFilterKey: 'pawns/getPawnsFilterKey',
			pawnsList: 'pawns/getPawnsList',
			userCity: 'location/getUserCity',
			showClosesStatus: 'pawns/getShowCloses',
			currentView: 'pawns/getCurrentViewMode',
			getCities: 'pawns/getCities',
			getDistricts: 'pawns/getDistricts'
		})
	},
	methods: {
		setFilter(filterKey, id) {
			let arr = this[filterKey]
			let index = arr.findIndex(i => i === id)
			if (index !== -1) {
				arr.splice(index, 1)
			} else {
				arr.push(id)
			}
			this[filterKey] = arr
		},
		...mapActions({
				loadFiltersData: 'pawns/loadFiltersData'
		}),
		...mapMutations({
			setPawnsFiltersKey: 'pawns/setPawnsFiltersKey',
			setShowClosest: 'pawns/setShowClosest',
			clearFilter: 'pawns/clearPawnsFilter',
			clearAdditionalFilters: 'pawns/clearAdditionalFilters'
		})
	}
}
</script>

<style scoped></style>
